import * as React from 'react';
import Form from '../../FormIO/presentation/FormWithValidations';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import {
    setShowSidebar,
    setShowHeader,
    setBypassReportImage
} from '../../../components/Application/redux-objects/actions';
import { view } from '../../WorkflowQueues/DataTranscriberValidation/redux-objects/actions';
import { IAppRouteLocation, IWorkflowItemStep } from '../../../common/sharedTypes';
import * as urls from '../../shared/urls';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';

interface IViewTValOwnProps {
  history: any;
}

interface IViewTvalActionProps {
  setShowSidebar?: (showSidebar: boolean) => void;
  setShowHeader?: (showHeader: boolean) => void;
  view:(workflowItemStep:IWorkflowItemStep) => void;
  setBypassReportImage?: (bypassReportImage: boolean) => void;
}
interface IViewTvalProps extends IViewTValOwnProps, IViewTvalActionProps {}

class ViewTval extends React.Component<IViewTvalProps> {
  private form: any;

  componentDidMount() {
    this.props.setShowSidebar(false);
    this.props.setShowHeader(false);
    this.props.setBypassReportImage(true);
    const urlParams = new URLSearchParams(window.location.search);
      var workflowItemStepId = urlParams.get("WFSID");

    Api.get(urls.GET_WORKFLOW_ITEM_STEP_BY_ID +"?id="+workflowItemStepId).then((response: ApiResponse<any>) => {
        if (response.ok) {
            this.props.view(response.data);
            setTimeout(() => {
              let location:IAppRouteLocation = {
                pathname:"/DataTranscriberValidation"
              };

              let locationState:any = {};
              locationState.readOnly = true;
              location.state = locationState;

              this.props.history.push(location);
            },1000);
        }
    });
  }

  public render() {

    return (
      <div id='formio'>
        <div className='container DataTranscriberForm'>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setShowSidebar,
  setShowHeader,
  setBypassReportImage,
  view
};

export default connect<any, IViewTvalActionProps>(
  null,
  mapDispatchToProps
)(ViewTval);
